import { del as networkDel } from '../../networkClient';
import { Path } from '../path';

export async function deleteScheduledMessage(messageId) {
  // networkDel does not throw on failure — it returns the axios error object.
  // Detect that shape and surface it as a structured error so callers can
  // distinguish success from failure.
  const response = await networkDel(
    Path.MESSAGE_BY_ID(messageId),
    undefined,
    null,
    null,
    true,
    true
  );
  if (response?.isAxiosError || response?.response) {
    return {
      error: true,
      message:
        response?.response?.data?.error ||
        response?.message ||
        'Request failed',
      status: response?.response?.status
    };
  }
  return response?.data;
}
